import { idHash, type Animator, type Gait, type Palette, type RigModel } from "./Rig";
import { LONGNECK_MODEL, LongneckAnimator, longneckColors } from "./longneck";
import { MOSSBACK_MODEL, MossbackAnimator, mossbackColors } from "./mossback";

/** The grazers come in two kinds, by id: mostly longnecks, with a mossback here and there. */
export type GrazerVariant = "longneck" | "mossback";
export const GRAZER_VARIANTS: readonly GrazerVariant[] = ["longneck", "mossback"];

export function grazerVariant(id: string): GrazerVariant {
  return idHash(id, 5) < 0.35 ? "mossback" : "longneck";
}

export interface GrazerKit {
  model: RigModel;
  palette: Palette;
  animator: Animator<Gait>;
}

/** Everything to draw one grazer: its rig, its colours and something to pose it. */
export function grazerKit(id: string, variant = grazerVariant(id)): GrazerKit {
  return variant === "mossback"
    ? { model: MOSSBACK_MODEL, palette: mossbackColors(id), animator: new MossbackAnimator(idHash(id)) }
    : { model: LONGNECK_MODEL, palette: longneckColors(id), animator: new LongneckAnimator(idHash(id)) };
}
